<template>
  <div class="list">
    <div class="orderListT">
      <div class="orderListThead">
        <img src="static/images/left1.png"  alt class="orderListTheadReturn" @click="back" />
        <p>订单记录</p>
        <img src="static/images/query.png"  alt class="orderListTheadQuery"/>
      </div>
      <div class="orderListTC">
        <h2>消费金额（元）</h2>
        <h3>{{orderInfo.total}}</h3>
      </div>
    </div>
    <div class="orderListC">
      <div class="orderListCT">
        <h4>消费明细</h4>
        <p>
          <img src="static/images/all.png"  alt/>
          查看全部
        </p>
      </div>

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <ul class="orderListCO">
          <li v-for="(item, index) in records" :key="index">
            <router-link :to="{name:'orderDetails', query: {id: item.id}}" class="orderListCOa">
              <div class="orderListCOE">
                <h4>{{item.orderNumber  }}</h4>
                <p>{{item.createTime}}</p>
              </div>
              <p class="orderListCOP">{{item.amountActuals}}</p>
            </router-link>
          </li>
        </ul>
      </van-list>
    </div>

  </div>
</template>

<script>
import {order} from "../../api/api"
export default {
  name: 'orderList',
  data () {
    return {
      orderInfo: {},
      records: [],
      loading: false,
      finished: false,
      params: {
        current: 1,
        size: 10
      }
    }
  },
  mounted() {
    this.orderList()
  },
  methods: {
    // 返回上一页
    back() {
      this.$router.go(-1)
    },
    // 加载更多
    onLoad() {
      this.params.current ++
      this.orderList()
    },
    // 订单记录
    orderList() {
      order(this, this.params).then(res => {
        if(res.code == 200) {
          this.orderInfo = res.data
          const list = res.data.page.records
          if(list == null || list.length === 0) {
            this.finished = true
            return
          }
          if (list.length < res.data.page.size) {
            this.finished = true
          }
          if (res.data.page.pages === 1) {
            this.records = list
          } else {
            this.records = this.records.concat(list)
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
 

</style>



// WEBPACK FOOTER //
// src/components/order/list.vue